import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface } from "@fluentui/react-components";
import { useState } from "react";
import { ValueInput } from "../ValueInput/ValueInput";
import type { IConfigurationEntity, SettingValueType } from "../../../interfaces";

export interface IEditDialogProps {
    value: SettingValueType;
    configurationEntity: IConfigurationEntity;
    onCancel(): void;
    onUpdate(value: SettingValueType): void;
}

export const EditDialog = (props: IEditDialogProps) => {
    const { value, configurationEntity, onCancel, onUpdate } = props;
    const [currentSettingsValue, setCurrentSettingsValue] = useState(value);
    const [isValid, setIsValid] = useState(false);

    const onUpdated = () => {
        onUpdate(currentSettingsValue);
    };

    const onIsValidChanged = (newIsValid: boolean): void => {
        setIsValid(newIsValid);
    };

    const onValueChanged = (newValue: SettingValueType): void => {
        setCurrentSettingsValue(newValue);
        if (typeof newValue === "boolean") {
            setIsValid(true);
        }
    };

    return (
        <Dialog open>
            <DialogSurface>
                <DialogBody>
                    <DialogContent>
                        <ValueInput
                            label={configurationEntity.shortDescription ?? configurationEntity.name}
                            value={currentSettingsValue}
                            entity={configurationEntity}
                            onIsValidChange={onIsValidChanged}
                            onValueChange={onValueChanged} />
                    </DialogContent>
                    <DialogActions>
                        <Button appearance="primary" onClick={() => onUpdated()} disabled={!isValid}>Apply</Button>
                        <Button appearance="secondary" onClick={() => onCancel()}>Cancel</Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};